import React, { memo, useCallback } from 'react';

import { Modal, Typography } from 'antd';

interface IProps {
  opened: boolean;
  submitDisabled?: boolean;
  submitLoading?: boolean;
  children: React.ReactNode;
  title?: string;
  message?: string | React.ReactNode;
  showOk?: boolean;
  showCancelButton?: boolean;
  customOkButton?: React.ReactNode;
  buttonOk?: string;
  buttonCancel?: string;
  disableBackdropClick?: boolean;
  onClose: () => void;
  onSubmit?: () => void;
}

const MyModal = memo(({ showOk = true, showCancelButton = true, ...props }: IProps) => {
  const handleOk = useCallback(() => props.onSubmit(), [props]);
  const handleCancel = useCallback(() => props.onClose(), [props]);

  if (!props.opened) {
    return null;
  }

  return (
    <Modal
      open={props.opened}
      onCancel={handleCancel}
      onOk={handleOk}
      maskClosable={!props.disableBackdropClick}
      width={600}
      title={props.title}
      okText={props.buttonOk ?? 'Prosseguir'}
      cancelText={props.buttonCancel ?? 'Cancelar'}
      confirmLoading={props.submitLoading}
      okButtonProps={{ disabled: props.submitDisabled, htmlType: 'submit' }}
      cancelButtonProps={{ type: 'text' }}
      footer={
        showOk && showCancelButton && !props.customOkButton
          ? undefined
          : (_, { OkBtn, CancelBtn }) => (
              <div className='flex flex-wrap items-center justify-end gap-2'>
                {showCancelButton && <CancelBtn />}
                {showOk && <OkBtn />}
                {props.customOkButton}
              </div>
            )
      }
    >
      {props.message && (
        <Typography.Paragraph type='secondary' className='mb-0 min-w-37.5'>
          {props.message}
        </Typography.Paragraph>
      )}
      {props.children}
    </Modal>
  );
});

export default MyModal;
